import Circle from "./zones/circle";
import Line from "./zones/line";
import Polygon from "./zones/polygon";

interface ActiveZones {
  subZones: Polygon[];
  cleaningZones: Polygon[];
  pylons: Line[];
  restrictedZones: Polygon[];
  cleaningCircles: Circle[];
  restrictedLines: Line[];
  roomLimitZone: Polygon | null;
}

export const initializedActiveZones = (activeZonesPartial: Partial<ActiveZones>): ActiveZones => {
  return {
    subZones: activeZonesPartial.subZones || [],
    cleaningZones: activeZonesPartial.cleaningZones || [],
    pylons: activeZonesPartial.pylons || [],
    restrictedZones: activeZonesPartial.restrictedZones || [],
    cleaningCircles: activeZonesPartial.cleaningCircles || [],
    restrictedLines: activeZonesPartial.restrictedLines || [],
    roomLimitZone: activeZonesPartial.roomLimitZone || null,
  };
};

export default ActiveZones;
